// Trailing-window slider math for the Constellations explorer.
//
// A slider pct (0..100, 100 = now) maps onto a trailing span of `spanDays`.
// API-bound values are QUANTIZED TO THE UTC DAY — floor for the window start,
// ceil for the window end — so a given slider position produces the identical
// window_start/window_end query params for a whole day. Every distinct param
// pair is a distinct backend cache key whose first-ever request pays a full
// (expensive) re-clustering inline, so bucket churn is the enemy: the earlier
// hour quantization still minted a brand-new cold key every wall-clock hour
// (the span trails Date.now()), which made windowed views recompute all day
// long (review ipqtuk). Day buckets cap that at one cold key per position per
// day, and the end bound's ceil keeps brand-new signals included.

const DAY_MS = 86_400_000;

function pctToMs(pct: number, spanDays: number, nowMs: number): number {
  return nowMs - ((100 - pct) / 100) * spanDays * DAY_MS;
}

export function pctToWindowISO(
  pct: number,
  spanDays: number,
  bound: 'start' | 'end',
  nowMs: number = Date.now(),
): string {
  const raw = pctToMs(pct, spanDays, nowMs);
  const snapped =
    bound === 'start'
      ? Math.floor(raw / DAY_MS) * DAY_MS
      : Math.ceil(raw / DAY_MS) * DAY_MS;
  return new Date(snapped).toISOString();
}

export function pctToWindowLabel(
  pct: number,
  spanDays: number,
  nowMs: number = Date.now(),
): string {
  return new Date(pctToMs(pct, spanDays, nowMs)).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
}
